import { extractErrorDetails } from '../../utils/functions/extractErrorDetails';

export const REACTIVATE_ERROR_TOAST_TITLE = 'Unable to Reactivate Membership';
export const DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE =
  "We're sorry, your transaction cannot be completed. Please try again.";
export const REACTIVATE_ERROR_CODE_LOG_MESSAGE = 'Reactivate Error Code';
export const REACTIVATE_UNMAPPED_ERROR_CODE_LOG_MESSAGE =
  'Reactivate Error Code without dedicated toast mapping';

const REACTIVATE_ERROR_TOAST_MESSAGES: Record<string, string> = {
  SUBSCRIPTION_ERROR: DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE,
  USER_ERROR: DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE,
  SEGMENT_ERROR: DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE,
  LOCALIZATION_ERROR: DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE,
  INVENTORY_ERROR:
    "We're sorry, some item(s) are no longer available. Please edit your cart and try again.",
  MEMBERSHIP_ERROR: DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE,
  PRODUCT_ERROR: DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE,
  TRANSACTION_DECLINED: 'Your transaction was declined. Please use a different card and try again.',
  TRANSACTION_ERROR:
    'Your transaction cannot be completed. Please verify your payment info and try again.',
  INVALID_SUBSCRIPTION_DATA: 'Some provided information was not accepted.',
  SHIPPING_RESTRICTED:
    "We're sorry, some item(s) cannot be delivered to your shipping location. Please choose a different delivery location or remove it from your cart.",
  ACTIVE_USER_EXISTS:
    "It looks like you're already a member of FabFitFun. Please login or use a different email address to create another account.",
  INACTIVE_USER_EXISTS:
    "It looks like you're already a member of FabFitFun. Request a login link to reactivate your membership.",
  INVALID_EMAIL: 'Your transaction cannot be completed. Please verify your email and try again.',
  INVALID_HCAPTHCHA: 'An error occurred while verifying captcha. Please try again.',
  INVALID_SHIPPING_ADDRESS:
    'Your transaction cannot be completed. Please verify your payment info and try again.',
  UNKNOWN_ERROR: DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE,
};

export const getReactivateErrorToastMessage = (
  errorCode?: string | null,
  apiMessage?: string | null,
): string => {
  if (apiMessage?.trim()) return apiMessage.trim();
  if (!errorCode) return DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE;
  return REACTIVATE_ERROR_TOAST_MESSAGES[errorCode] ?? DEFAULT_REACTIVATE_ERROR_TOAST_MESSAGE;
};

export const hasMappedReactivateErrorToastMessage = (errorCode?: string | null): boolean =>
  Boolean(errorCode && REACTIVATE_ERROR_TOAST_MESSAGES[errorCode]);

export const getErrorDetailsFromReactivateResponse = async (
  response: Response | undefined,
): Promise<{ errorCode?: string; errorMessage?: string }> => {
  if (!response || response.ok) return {};

  try {
    const responseBody = await response.clone().json();
    const { errorCode, errorMessage } = extractErrorDetails(responseBody);
    return {
      errorCode,
      errorMessage,
    };
  } catch {
    return {};
  }
};
